<template>
  <NavbarApp />
  <div class="team-page">
    <div class="content-section" ref="OurTeam">
      <div class="left-nav-section">
        
      </div>
      <div class="right-content-section">
        
        <section class="text-block">
          <p>
            {{ $t('team.ourTeamSection.paragraph2') }}
          </p>
        </section>
        <section class="text-block">
          <p v-html="$t('team.ourTeamSection.paragraph3')"></p>
        </section>
      </div>
    </div>

    <div class="content-section" ref="Partners">
      <div class="left-nav-section">
        <ul>
          
          <li><span :class="{'nav-title': true, 'active-nav': activeSection === 'Partners'}" @click="goToPartners">{{ $t('team.nav.partners') }}</span></li>
          <li><span :class="{'nav-subtitle': true, 'active-nav': activeSection === 'Associates'}" @click="goToAssociates">{{ $t('team.nav.associates') }}</span></li>
          <li><span :class="{'nav-subtitle': true, 'active-nav': activeSection === 'External'}" @click="goToExternal">{{ $t('team.nav.externalPartners') }}</span></li>
        </ul>
      </div>
      <div class="right-content-section">
        <TeamListing :teamMembers="partnersTeamMembers" />
      </div>
    </div>

    <div class="content-section" ref="Associates">
      <div class="left-nav-section">
        <ul>
          
          <li><span :class="{'nav-subtitle': true, 'active-nav': activeSection === 'Partners'}" @click="goToPartners">{{ $t('team.nav.partners') }}</span></li>
          <li><span :class="{'nav-title': true, 'active-nav': activeSection === 'Associates'}" @click="goToAssociates">{{ $t('team.nav.associates') }}</span></li>
          <li><span :class="{'nav-subtitle': true, 'active-nav': activeSection === 'External'}" @click="goToExternal">{{ $t('team.nav.externalPartners') }}</span></li>
        </ul>
      </div>
      <div class="right-content-section">
        <TeamGrid :teamMembers="gridAssociates" />
      </div>
    </div>

    <div class="content-section external-partners-section" ref="External">
      <div class="left-nav-section">
        <ul>
          
          <li><span :class="{'nav-subtitle': true, 'active-nav': activeSection === 'Partners'}" @click="goToPartners">{{ $t('team.nav.partners') }}</span></li>
          <li><span :class="{'nav-subtitle': true, 'active-nav': activeSection === 'Associates'}" @click="goToAssociates">{{ $t('team.nav.associates') }}</span></li>
          <li><span :class="{'nav-title': true, 'active-nav': activeSection === 'External'}" @click="goToExternal">{{ $t('team.nav.externalPartners') }}</span></li>
        </ul>
      </div>
      <div class="right-content-section logo-grid">
        <a href="https://www.nortonrosefulbright.com/" target="_blank" rel="noopener noreferrer">
  <img src="/parteners/Norton-Rose-Fulbright.png" alt="Norton Rose Fulbright"/>
</a>

<a href="https://www.whitecase.com/" target="_blank" rel="noopener noreferrer">
  <img src="/parteners/White-Case-LLP.png" alt="White Case LLP"/>
</a>
<a href="https://www.druces.com/" target="_blank" rel="noopener noreferrer">
  <img src="/parteners/Druces-LLP.png" alt="Druces LLP"/>
</a>
<a href="https://www.herbertsmithfreehills.com/" target="_blank" rel="noopener noreferrer">
  <img src="/parteners/Herbert-Smith-Freehills.png" alt="Herbert Smith Freehills"/>
</a>
      </div>
    </div>
  </div>
  <Section4/>
</template>

<script>
import NavbarApp from '../components/HomePage/navbar-law.vue';
import Section4 from '../components/HomePage/section-4.vue';
import TeamListing from '@/components/Team/TeamListing.vue';
import TeamGrid from '@/components/Team/TeamGrid.vue';
// Correctly import 'teamMembers' from your data file
import { teamMembers } from '@/data/team';
import { teamAssociated } from '@/data/associated';

export default {
  name: 'TeamPage',
  components: {
    NavbarApp,
    Section4,
    TeamListing,
    TeamGrid
    
  },
  data() {
    return {
      activeSection: 'OurTeam',
      // Assign the imported teamMembers to detailedTeamMembers
      detailedTeamMembers: teamMembers,
      detailedAssociated: teamAssociated
    };
  },
  computed: {
    // Filter for partners to pass to TeamListing
    partnersTeamMembers() {
      // Ensure 'member.category' matches your data
      return this.detailedTeamMembers.filter(member => member.category === 'partner');
    },
    // Filter for associates and counsel for the grid
    gridAssociates() {
      // Ensure these categories match your data
      return this.detailedAssociated.filter(member =>
        ['senior associate', 'junior associate', 'counsel'].includes(member.category)
      );
    }
  },
  methods: {
    goToOurTeam() {
      this.$refs.OurTeam.scrollIntoView({ behavior: 'smooth' });
      this.activeSection = 'OurTeam';
    },
    goToPartners() {
      this.$refs.Partners.scrollIntoView({ behavior: 'smooth' });
      this.activeSection = 'Partners';
    },
    goToAssociates() {
      this.$refs.Associates.scrollIntoView({ behavior: 'smooth' });
      this.activeSection = 'Associates';
    },
    goToExternal() {
      this.$refs.External.scrollIntoView({ behavior: 'smooth' });
      this.activeSection = 'External';
    },
    handleIntersect(entries) {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.activeSection = entry.target.dataset.section;
        }
      });
    }
  },
  mounted() {
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0.5
    };
    const observer = new IntersectionObserver(this.handleIntersect, options);

    if (this.$refs.OurTeam) {
      this.$refs.OurTeam.dataset.section = 'OurTeam';
      observer.observe(this.$refs.OurTeam);
    }
    if (this.$refs.Partners) {
      this.$refs.Partners.dataset.section = 'Partners';
      observer.observe(this.$refs.Partners);
    }
    if (this.$refs.Associates) {
      this.$refs.Associates.dataset.section = 'Associates';
      observer.observe(this.$refs.Associates);
    }
    if (this.$refs.External) {
      this.$refs.External.dataset.section = 'External';
      observer.observe(this.$refs.External);
    }
    this.observer = observer;
  },
  beforeUnmount() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
};
</script>

<style scoped>
/*
  All the general layout styles for the team page,
  left navigation, intro text blocks, and external partners section
  (e.g., .team-page, .content-section, .left-nav-section,
  .right-content-section, .nav-title, .nav-subtitle, .text-block,
  .external-partners-section, .logo-grid, and their respective media queries)
  should be placed here.
*/

.team-page {
  min-height: 100vh;
  overflow-x: hidden;
}

.content-section {
  display: flex;
  width: 100%;
  border-bottom: 1px solid #eee;
  background-color: #fff;
  padding: 20px 0;
}

.left-nav-section {
  width: 20%;
  padding: 20px 0;
  box-sizing: border-box;
  background-color: rgb(255, 255, 255);
  padding-left: 20px;
}

.right-content-section {
  width: 80%;
  padding: 20px 40px;
  box-sizing: border-box;
  background-color: #ffffff;
   text-align: justify;
  text-justify: inter-word;
}

/* --- Left Navigation Styling --- */
.team-page .left-nav-section ul {
  list-style: none;
  list-style-type: none;
  padding: 0;
  margin: 0;
}

.team-page .left-nav-section li {
  margin-bottom: 10px;
  list-style-type: none;
}

.nav-title,
.nav-subtitle {
  cursor: pointer;
  color: #333;
  font-size: 1.1rem;
  padding: 5px 0;
  display: inline-block;
  transition: color 0.3s ease, font-weight 0.3s ease;
  list-style-type: none;
}

.nav-title {
  font-weight: bold;
  color: rgb(0, 0, 0);
}

.nav-subtitle:hover,
.nav-title:hover {
  color: #bbd55a;
  text-decoration: underline;
}

/* --- Content-1 (Our Team Intro) Styling --- */
.text-block {
  margin-bottom: 25px;
  line-height: 1.6;
  font-size: 1.4rem; /* Kept large as it's an intro text */
  color: #555;
  max-width: 1000px;
  text-align: justify;
}
.text-block p {
  margin-top: 0;
}

.text-block strong {
  color: #333;
}

/* --- External Partners Styling --- */
.external-partners-section .right-content-section.logo-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 30px;
  justify-content: center;
  align-items: center;
  padding: 40px;
}

.external-partners-section .right-content-section.logo-grid img {
  width: 150px;
  height: 150px;
  object-fit: contain;
  display: block;
  transition: transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out;
  cursor: pointer;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  padding: 15px;
  background-color: #ffffff;
  border: 1px solid #eee;
}

.external-partners-section .right-content-section.logo-grid img:hover {
  transform: translateY(-8px) scale(1.05);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
}

/* --- Media Queries (Remaining styles from TeamPage.vue) --- */

/* Tablet (max-width: 992px) */
@media (max-width: 992px) {
  .left-nav-section {
    width: 25%;
  }
  .right-content-section {
    width: 75%;
    padding: 20px;
  }
  .text-block {
    font-size: 1.5rem;
  }
  .external-partners-section .right-content-section.logo-grid img {
    width: 100px;
    height: 100px;
    padding: 8px;
  }
}

/* Mobile (max-width: 768px) */
@media (max-width: 768px) {
  .content-section {
    flex-direction: column;
  }
  .left-nav-section {
    width: 100%;
    padding: 15px 20px;
    text-align: center;
    border-bottom: 1px solid #eee;
    overflow-x: auto;
    white-space: nowrap;
  }
  .left-nav-section ul {
    display: inline-flex;
    justify-content: flex-start;
    gap: 15px;
  }
  .left-nav-section li {
    flex-shrink: 0;
    margin-bottom: 0;
  }
  .nav-title,
  .nav-subtitle {
    font-size: 1rem;
    padding: 5px 10px;
  }
  .right-content-section {
    width: 100%;
    padding: 20px;
  }
  .text-block {
    font-size: 1.2rem;
  }
  .external-partners-section .right-content-section.logo-grid {
    gap: 15px;
    padding: 15px;
  }
  .external-partners-section .right-content-section.logo-grid img {
    width: 70px;
    height: 70px;
    padding: 5px;
  }
}

/* Very Small Mobile (max-width: 480px) */
@media (max-width: 480px) {
  .text-block {
    font-size: 1rem;
  }
  .nav-title,
  .nav-subtitle {
    font-size: 0.9rem;
  }
  .external-partners-section .right-content-section.logo-grid img {
    width: 60px;
    height: 60px;
    padding: 3px;
  }
}
</style>